import { BannerLayout } from "@sourceful/shared-types";
import { getSanityImgUrl } from "@lib/sanity";

// BANNER CONTENT HELPERS

// Banner content is placed on a 4 x 4 grid
export const getContentGridCol = (layout: BannerLayout, hasAdequateSpace?: boolean) => {
  if (!hasAdequateSpace) {
    return "1 / span 4";
  }

  switch (layout) {
    case BannerLayout.TEXT_PANEL_LEFT:
      return "1 / span 2";
    case BannerLayout.TEXT_PANEL_RIGHT:
      return "3 / span 2";
    default:
      return "1 / span 4";
  }
};

export const getContentGridRow = (layout: BannerLayout, hasAdequateSpace?: boolean) => {
  if (!hasAdequateSpace) {
    return "1 / span 2"; // default to text panel on top
  }

  switch (layout) {
    case BannerLayout.TEXT_PANEL_TOP:
      return "1 / span 2";
    case BannerLayout.TEXT_PANEL_BOTTOM:
      return "3 / span 2";
    default:
      return "1 / span 4";
  }
};

// IMAGE HELPERS
export const getForegroundImageSrc = (ref: string, layout: BannerLayout) => {
  const needsWiderImage =
    layout === BannerLayout.TEXT_PANEL_BOTTOM ||
    layout === BannerLayout.TEXT_PANEL_TOP ||
    layout === BannerLayout.TEXT_PANEL_CENTRE;
  return getSanityImgUrl(ref, base => base.width(needsWiderImage ? 1200 : 600));
};

// Banner content is placed on a 4 x 4 grid
export const getImageGridColumn = (layout: BannerLayout, hasAdequateSpace?: boolean) => {
  const DEFAULT_PLACEMENT = "1 / span 4";

  if (!hasAdequateSpace) {
    return DEFAULT_PLACEMENT;
  }

  switch (layout) {
    case BannerLayout.TEXT_PANEL_LEFT:
      return "3 / span 2";
    case BannerLayout.TEXT_PANEL_RIGHT:
      return "1 / span 2";
    default:
      return DEFAULT_PLACEMENT;
  }
};

export const getImageGridRow = (layout: BannerLayout, hasAdequateSpace?: boolean) => {
  const DEFAULT_PLACEMENT = "3 / span 2";
  if (!hasAdequateSpace) {
    return DEFAULT_PLACEMENT;
  }

  switch (layout) {
    case BannerLayout.TEXT_PANEL_LEFT:
      return "1 / span 4";
    case BannerLayout.TEXT_PANEL_RIGHT:
      return "1 / span 4";
    case BannerLayout.TEXT_PANEL_TOP:
      return "3 / span 2";
    case BannerLayout.TEXT_PANEL_BOTTOM:
      return "1 / span 2";
    case BannerLayout.TEXT_PANEL_CENTRE:
      return "1 / span 4"; // Foreground image covers whole banner if text panel is placed in center
    default:
      return DEFAULT_PLACEMENT;
  }
};
